import Rails from "@rails/ujs";
import gridOverlay from "./lib/gridOverlay";
import responsiveEmbeds from "./lib/responsiveEmbeds";
import themeToggle from "./lib/themeToggle";

Rails.start();

document.addEventListener("DOMContentLoaded", () => {
  responsiveEmbeds();
  gridOverlay();
  themeToggle();
});
